import * as _ from "lodash"
import { Exclude, Expose } from "class-transformer"

enum Filters {
    IS_DOMESTIC,
    IS_NOT_DOMESTIC,
    IS_DOMESTIC_OR_CROATIA,
    IS_DOMESTIC_OR_SLOVENIA,
    IS_DOMESTIC_OR_ROAD_EXPORT,
    IS_COD_COUNTRY,
    IS_PARCEL_SHOP_COUNTRY
}

enum Statuses {
    MANDATORY,
    DISABLED,
    OPTIONAL
}

@Exclude()
export class DpdProductVariantOption {
    @Expose({ name: "expressionToDisable" })
    readonly expressionToDisable!: string

    @Expose({ name: "expressionWhenDisabled" })
    readonly expressionWhenDisabled?: string
}
